import { NavLink, useNavigate, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import t from "@/lang/lang";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { HtzBreadcrumbs } from "@/routes/processes/[processId]/htz/_components/htz-breadcrumbs";
import {
  SummariesTable,
  SummaryTableFilters,
  useDefaultHtzSummaryListRequest,
} from "@/services/backend/htz/summary/components/summaries-table";
import { Summary } from "@/services/backend/htz/summary/types/summary";
import { SummaryCreateButton } from "@/services/backend/htz/summary/components/summary-create-button";

export function SummariesIndexRoute() {
  const { processId } = useParams();
  const navigate = useNavigate();
  const { data } = useProcessesProcessShowQuery({ id: processId! });

  const [request, setRequest] = useState(
    useDefaultHtzSummaryListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (summary: Summary, children: ReactNode) => (
      <NavLink to={summary.id}>{children}</NavLink>
    ),
    [],
  );

  if (!data) return null;

  const breadcrumbs = (
    <HtzBreadcrumbs customerId={data.customerId} processId={data.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Inspektionsberichte")}</BreadcrumbPage>
      </BreadcrumbItem>
    </HtzBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <MilestonePage>
        <MilestonePageHeader>
          <MilestonePageTitle>{t("Inspektionsberichte")}</MilestonePageTitle>
        </MilestonePageHeader>
        <MilestonePageContent>
          <div className="grid gap-2">
            <div className="flex justify-between">
              <SummaryTableFilters
                request={request}
                onRequestChange={setRequest}
              />
              <SummaryCreateButton
                processId={processId!}
                onSuccess={(summaryId) => navigate(summaryId)}
              />
            </div>
            <SummariesTable
              request={request}
              onRequestChange={setRequest}
              renderRowLink={renderRowLink}
            />
          </div>
        </MilestonePageContent>
      </MilestonePage>
    </ProcessPageMainTemplate>
  );
}
